/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Radial/view.blocks to change it.
import Body from 'DesignSystem/Body/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Radial({
  children,
  viewPath = "/DesignSystem/Radial",
  alignItems = "center",
  isDisabled,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  width = "auto",
  onClick,
  paddingBottom = 4,
  paddingRight = 8,
  paddingTop = 4,
  isSelected,
  textMarginLeft = 8,
  text,
  fontWeight,
  fontSize
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="Radial.Horizontal"
  data-view-path={viewPath}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ai-1-Z2bWdyX': alignItems,'--mt-2-Z2bWdyX': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-3-Z2bWdyX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-4-Z2bWdyX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--w-5-Z2bWdyX': typeof width === 'number' ? `${width}px` : width,'--pb-6-Z2bWdyX': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pr-7-Z2bWdyX': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-8-Z2bWdyX': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Radial.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-9-Z2bWdyX': isSelected ? "rgb(0,150,89)" : isHovered ? "rgba(0, 188, 112, 0.83)" : "#ebebeb"}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Radial.Vertical"
  data-view-path={viewPath}
 style={{'--bc-10-Z2bWdyX': isSelected ? "rgb(0,150,89)" : "rgba(0, 0, 0, 0)",'--o-11-Z2bWdyX': isSelected ? 1 : 0}}
 className={`views-block ${styles.Vertical}`}
/>
</div>
<Body
  viewPath={`${viewPath}/Body`}
 marginLeft={textMarginLeft}
 text={text}
 weight={fontWeight}
 size={fontSize}
 textOverflow="none"
 overflowX="visible"
/>
</button>
{children}
</React.Fragment>)
}